import { useMutation } from '@tanstack/react-query';
import { POST_STORE_QR, POST } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useGetStoreQr = () =>
  useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_STORE_QR(), payload);
      return response;
    },
    onSuccess: (data) => {
      openAlert({
        type: 'success',
        model: 'message',
        message: data?.message,
      });
    },
    onError: (error) => {
      openAlert({
        type: 'error',
        model: 'message',
        message: error?.message,
      });
    },
  });
